import styled from "styled-components";

//MISC
import {
  COLORS,
  SIZE,
  BORDER_RADIUS,
  DEVICE_TYPE,
  MARGIN,
} from "constants/variables";

//ASETS
import cursorIcon from "assets/img/Cursor.png";
export const IframeWrapper = styled.div<{ biggerCursor?: boolean }>`
  width: 100%;
  height: 600px;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 24px;
  }
  padding: 8px;
  background-color: ${COLORS.VividAuburn};
  border-radius: 24px;
`;

export const CardWrapper = styled.div<{ biggerCursor?: boolean }>`
  /* cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  cursor: default; */
  background-color: ${COLORS.Cultured};
  border: solid 1px ${COLORS.AbsoluteWhite};
  border-radius: ${BORDER_RADIUS.radius24};
  min-width: 200px;
  width: 14rem;
  max-width: 240px;
  min-height: 210px;
  height: 16rem;
  max-height: 260px;
  padding: ${SIZE.max40};
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-decoration: none;
  gap: 4px;
  position: relative;
  transition: background-color 0.3s ease-in-out;

  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
    max-width: 100%;

    height: 165px;
    min-height: 165px;
    padding: ${MARGIN.max24} ${MARGIN.max24} ${MARGIN.max24} ${MARGIN.max24};
  }
  &:hover {
    background-color: ${COLORS.Background};
    transition: background-color 0.3s ease-in-out;
  }
`;

export const TextWrapper = styled.div`
  &:first-child {
    text-transform: uppercase;
  }
  &:nth-child(2) {
    width: 80%;
    display: -webkit-box;
    overflow: hidden !important;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    margin-bottom: ${SIZE.max40};
    @media (max-width: ${DEVICE_TYPE.mobile}) {
      margin-bottom: 0px;
      -webkit-line-clamp: 3;
    }
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: ${SIZE.max24};
  bottom: ${SIZE.max24};
  svg {
    max-height: 72px;
    width: auto;
    @media (max-width: ${DEVICE_TYPE.tablet}) {
      max-height: 60px;
    }
  }
`;
export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  /* background-color: red; */
  gap: 24px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    flex-direction: column;
  }
`;
